/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/lv_LV';
import DatePicker from './date-picker/lv_LV';
import Pagination from './pagination/lv_LV';
import TimePicker from './time-picker/lv_LV';

export default {
  locale: 'lv',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'FiltrÄÅ¡anas izvÄlne',
    filterConfirm: 'OK',
    filterReset: 'AtiestatÄ«t',
    selectAll: 'Atlasiet paÅ¡reizÄjo lapu',
    selectInvert: 'PÄrvÄrst paÅ¡reizÄjo lapu'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Atcelt',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Atcelt'
  },
  Transfer: {
    searchPlaceholder: 'MeklÄt Å¡eit',
    itemUnit: 'vienumu',
    itemsUnit: 'vienumus'
  },
  Upload: {
    uploading: 'AugÅ¡upielÄde...',
    removeFile: 'NoÅemt failu',
    uploadError: 'AugÅ¡upielÄdes kÄ¼Å«da',
    previewFile: 'PriekÅ¡skatiet failu'
  },
  Empty: {
    description: 'Nav datu'
  }
};
